/* ---------- Catalogue des prestations (prix indicatifs, utilisés pour l'estimation) ---------- */
const SERVICES = [{"id": "vitrine", "name": "Création de site vitrine", "price": 690}, {"id": "ecommerce", "name": "Création de boutique e-commerce", "price": 1490}, {"id": "shopify", "name": "Création et personnalisation Shopify", "price": 1290}, {"id": "branding", "name": "Branding & identité visuelle", "price": 590}, {"id": "logo", "name": "Création de logo", "price": 290}, {"id": "social", "name": "Réseaux sociaux", "price": 190}, {"id": "contenu", "name": "Création de contenus et visuels", "price": 350}, {"id": "mockups", "name": "Mockups", "price": 90}, {"id": "maintenance", "name": "Maintenance", "price": 70}, {"id": "optimisation", "name": "Optimisation de site", "price": 250}];
const EXTRA_SERVICES = [
  {id:'photographe', name:'Photographe / vidéaste', price:250},
  {id:'autre', name:'Autre prestation', price:null},
];
const ALL_SERVICES = SERVICES.concat(EXTRA_SERVICES);
const serviceById = id => ALL_SERVICES.find(s=>s.id===id);
const fmt = n => n.toLocaleString('fr-FR') + ' €';

const cart = new Set();
function renderOfferButtons(){
  document.querySelectorAll('.add[data-id]').forEach(b=>{
    const on = cart.has(b.dataset.id);
    b.setAttribute('aria-pressed', on);
    b.textContent = on ? 'Ajouté au devis' : 'Ajouter à mon devis';
  });
  document.getElementById('headCount').textContent = cart.size;
}
document.addEventListener('click', e=>{
  const b = e.target.closest('.add[data-id]');
  if(!b) return;
  cart.has(b.dataset.id) ? cart.delete(b.dataset.id) : cart.add(b.dataset.id);
  renderOfferButtons();
  syncStep0Checkboxes();
  rebuildSteps();
  renderSummary();
});

const filtersEl = document.getElementById('filters');
if(filtersEl) filtersEl.addEventListener('click', e=>{
  const b = e.target.closest('.filter-btn'); if(!b) return;
  document.querySelectorAll('.filter-btn').forEach(x=>x.classList.remove('active'));
  b.classList.add('active');
  const f = b.dataset.filter;
  document.querySelectorAll('.wk-card').forEach(card=>{
    const cats = (card.dataset.cat||'').split(' ');
    card.classList.toggle('hide', f!=='all' && !cats.includes(f));
  });
});

const PRESTATION_CHOICES = [
  {id:'vitrine', label:'Création de site vitrine'},
  {id:'shopify', label:'Création / personnalisation Shopify'},
  {id:'branding', label:'Branding & identité visuelle'},
  {id:'logo', label:'Création de logo'},
  {id:'social', label:'Réseaux sociaux'},
  {id:'contenu', label:'Création de contenu & visuels'},
  {id:'mockups', label:'Mockups'},
  {id:'maintenance', label:'Maintenance'},
  {id:'optimisation', label:'Optimisation de site'},
  {id:'photographe', label:'Photographe / vidéaste'},
  {id:'autre', label:'Autre'},
];
function prestationKey(id){ return id === 'ecommerce' ? 'shopify' : id; }

const SUBFORMS = {

  vitrine: {title:'Création de site vitrine', fields:[
    {type:'text', id:'v_activite', label:'Quelle est votre activité ?'},
    {type:'checkbox-group', id:'v_objectif', label:"Quel est l'objectif de votre site ?", options:[
      'Présenter mon entreprise','Présenter mes services','Obtenir des demandes de contact','Obtenir des rendez-vous','Présenter mes réalisations','Développer ma visibilité','Autre']},
    {type:'checkbox-group', id:'v_pages_nb', label:'Combien de pages souhaitez-vous ?', options:[
      '1 à 3','4 à 6','7 à 10','Plus de 10','Je ne sais pas encore']},
    {type:'checkbox-group', id:'v_pages', label:'Quelles pages souhaitez-vous ?', options:[
      'Accueil','À propos','Services','Réalisations / Portfolio','Contact','Tarifs','Blog','Autre']},
    {type:'radio', id:'v_logo', label:'Avez-vous déjà un logo ?', options:['Oui','Non'],
      reveal:{when:'Non', type:'checkbox', id:'v_logo_add', label:"Ajouter la création d'un logo à mon devis", add:'logo'}},
    {type:'radio', id:'v_couleurs', label:'Avez-vous déjà vos couleurs ?', options:['Oui','Non'],
      reveal:{when:'Non', type:'checkbox', id:'v_couleurs_add', label:'Je souhaite que TCHService définisse les couleurs'}},
    {type:'checkbox-group', id:'v_style', label:'Quel style souhaitez-vous ?', options:[
      'Luxe','Moderne','Minimaliste','Premium','Professionnel','Sport','Créatif','Je ne sais pas encore']},
    {type:'radio', id:'v_exemples', label:'Avez-vous des exemples de sites que vous aimez ?', options:['Oui','Non'],
      reveal:{when:'Oui', type:'text', id:'v_exemples_liens', label:'Liens des sites'}},
    {type:'radio', id:'v_slogan', label:"Avez-vous un slogan ou une phrase d'accroche ?", options:['Oui','Non']},
    {type:'radio', id:'v_textes', label:'Avez-vous déjà vos textes ?', options:['Oui','Non','Partiellement'],
      reveal:{when:['Non','Partiellement'], type:'checkbox', id:'v_textes_add', label:'Je souhaite une aide pour la rédaction'}},
    {type:'radio', id:'v_photos', label:'Avez-vous vos photos / vidéos ?', options:['Oui','Non','Partiellement'],
      reveal:{when:'Non', type:'checkbox', id:'v_photos_add', label:'Je souhaite créer des photos / vidéos', add:'photographe'}},
    {type:'checkbox-group', id:'v_fonctionnalites', label:'Fonctionnalités', options:[
      'Formulaire de contact','Prise de rendez-vous','Galerie photos','Portfolio / réalisations','Google Maps','Réseaux sociaux','Témoignages clients','Blog','Autre']},
    {type:'radio', id:'v_domaine', label:'Avez-vous déjà un nom de domaine ?', options:['Oui','Non','Je ne sais pas'],
      reveal:{when:'Non', type:'checkbox', id:'v_domaine_add', label:"Je souhaite que TCHService s'occupe du nom de domaine"}},
    {type:'radio', id:'v_hebergement', label:'Avez-vous déjà un hébergement ?', options:['Oui','Non','Je ne sais pas']},
    {type:'radio', id:'v_mentions', label:'Avez-vous vos mentions légales ?', options:['Oui','Non']},
    {type:'radio', id:'v_confidentialite', label:'Avez-vous votre politique de confidentialité ?', options:['Oui','Non']},
    {type:'radio', id:'v_cgv', label:'Avez-vous vos CGV ?', options:['Oui','Non','Non nécessaire']},
    {type:'checkbox-group', id:'v_deadline', label:'Quelle est votre deadline ?', options:[
      'Dès que possible','Dans le mois','Dans 1 à 3 mois','Plus de 3 mois','Pas de délai particulier']},
    {type:'checkbox-group', id:'v_budget', label:'Quel est votre budget ?', options:[
      'Moins de 500 €','500 – 1 000 €','1 000 – 2 000 €','2 000 – 5 000 €','Plus de 5 000 €','Je ne sais pas encore']},
  ]},

  shopify: {title:'Création / personnalisation Shopify', fields:[
    {type:'text', id:'s_vendre', label:'Que souhaitez-vous vendre ?'},
    {type:'checkbox-group', id:'s_nb_produits', label:'Combien de produits souhaitez-vous mettre en ligne ?', options:[
      '1 à 10','11 à 30','31 à 50','51 à 100','Plus de 100','Je ne sais pas encore']},
    {type:'radio', id:'s_variantes', label:'Avez-vous des variantes ?', options:['Oui','Non'],
      reveal:{when:'Oui', type:'checkbox-group', id:'s_variantes_type', label:'', options:['Taille','Couleur','Modèle','Autre']}},
    {type:'radio', id:'s_prix', label:'Avez-vous déjà vos prix ?', options:['Oui','Non']},
    {type:'radio', id:'s_descriptions', label:'Avez-vous déjà vos descriptions produits ?', options:['Oui','Non','Partiellement'],
      reveal:{when:['Non','Partiellement'], type:'checkbox', id:'s_descriptions_add', label:'Ajouter la rédaction des fiches produits à mon devis'}},
    {type:'radio', id:'s_photos', label:'Avez-vous vos photos / vidéos produits ?', options:['Oui','Non','Partiellement']},
    {type:'radio', id:'s_logo', label:'Avez-vous déjà un logo ?', options:['Oui','Non'],
      reveal:{when:'Non', type:'checkbox', id:'s_logo_add', label:"Ajouter la création d'un logo à mon devis", add:'logo'}},
    {type:'radio', id:'s_couleurs', label:'Avez-vous déjà vos couleurs ?', options:['Oui','Non']},
    {type:'checkbox-group', id:'s_style', label:'Quel style souhaitez-vous ?', options:[
      'Luxe','Premium','Moderne','Minimaliste','Sport','Streetwear','Tech','Autre','Je ne sais pas encore']},
    {type:'radio', id:'s_exemples', label:'Avez-vous des exemples de boutiques que vous aimez ?', options:['Oui','Non'],
      reveal:{when:'Oui', type:'text', id:'s_exemples_liens', label:'Liens des boutiques'}},
    {type:'radio', id:'s_slogan', label:"Avez-vous un slogan ou une phrase d'accroche ?", options:['Oui','Non']},
    {type:'checkbox-group', id:'s_paiement', label:'Quels moyens de paiement souhaitez-vous ?', options:[
      'Carte bancaire','PayPal','Paiement en plusieurs fois','Autre','Je ne sais pas encore']},
    {type:'checkbox-group', id:'s_livraison', label:'Comment souhaitez-vous livrer vos clients ?', options:[
      'Livraison à domicile','Point relais','Retrait sur place','Livraison internationale','Je ne sais pas encore']},
    {type:'radio', id:'s_tarifs_livraison', label:'Avez-vous déjà vos tarifs de livraison ?', options:['Oui','Non']},
    {type:'checkbox-group', id:'s_fonctionnalites', label:'Fonctionnalités', options:[
      'Avis clients','Codes promotionnels','Newsletter','Compte client','Suivi de commande','Liste de souhaits','Instagram / TikTok','Pop-up / offre promotionnelle','Autre']},
    {type:'radio', id:'s_cgv', label:'Avez-vous vos CGV ?', options:['Oui','Non']},
    {type:'radio', id:'s_remboursement', label:'Avez-vous votre politique de remboursement ?', options:['Oui','Non']},
    {type:'radio', id:'s_mentions', label:'Avez-vous vos mentions légales ?', options:['Oui','Non']},
    {type:'radio', id:'s_confidentialite', label:'Avez-vous votre politique de confidentialité ?', options:['Oui','Non']},
    {type:'radio', id:'s_deja_shopify', label:'Avez-vous déjà une boutique Shopify ?', options:['Oui','Non'],
      reveal:{when:'Oui', type:'text', id:'s_deja_shopify_url', label:'Adresse de votre boutique'}},
    {type:'checkbox-group', id:'s_deadline', label:'Quelle est votre deadline ?', options:[
      'Dès que possible','Dans le mois','Dans 1 à 3 mois','Plus de 3 mois','Pas de délai particulier']},
    {type:'checkbox-group', id:'s_budget', label:'Quel est votre budget ?', options:[
      'Moins de 500 €','500 – 1 000 €','1 000 – 2 000 €','2 000 – 5 000 €','Plus de 5 000 €','Je ne sais pas encore']},
  ]},

  branding: {title:'Branding & identité visuelle', fields:[
    {type:'checkbox-group', id:'b_besoin', label:'Que souhaitez-vous ?', options:[
      'Identité visuelle complète','Charte graphique','Couleurs de marque','Typographies','Supports de communication','Refonte de mon identité']},
    {type:'checkbox-group', id:'b_style', label:'Style souhaité', options:[
      'Luxe','Premium','Moderne','Minimaliste','Sport','Créatif','Autre']},
  ]},

  logo: {title:'Création de logo', fields:[
    {type:'checkbox-group', id:'l_type', label:'Votre besoin', options:[
      "Création d'un nouveau logo",'Refonte d\'un logo existant','Logo avec symbole','Logo typographique','Monogramme','Plusieurs propositions','Version noir & blanc','Fichiers professionnels du logo']},
  ]},

  social: {title:'Réseaux sociaux', fields:[
    {type:'checkbox-group', id:'so_plateformes', label:'Plateformes concernées', options:[
      'Instagram','TikTok','Facebook','LinkedIn','Autre']},
    {type:'checkbox-group', id:'so_besoin', label:'Besoin', options:[
      'Création du compte','Optimisation du profil','Publications','Stories','Reels','Gestion des réseaux','Stratégie de contenu']},
  ]},

  contenu: {title:'Création de contenu & visuels', fields:[
    {type:'checkbox-group', id:'c_besoin', label:'Votre besoin', options:[
      'Publications','Stories','Carrousels','Reels','Vidéos','Publicités','Flyers','Affiches','Bannières','Visuels produits','Autre']},
  ]},

  mockups: {title:'Mockups', fields:[
    {type:'checkbox-group', id:'m_type', label:'Type de mockups', options:[
      'Produit','Vêtement','Packaging','Téléphone','Ordinateur','Site internet','Carte de visite','Autre']},
  ]},

  maintenance: {title:'Maintenance', fields:[
    {type:'checkbox-group', id:'ma_besoin', label:'Votre besoin', options:[
      'Mise à jour du site','Modification de contenu','Ajout de produits','Correction de problèmes','Sauvegarde','Suivi du site','Optimisation']},
    {type:'checkbox-group', id:'ma_formule', label:'Formule souhaitée', options:[
      'Ponctuelle','Mensuelle','Je ne sais pas encore']},
  ]},

  optimisation: {title:'Optimisation de site', fields:[
    {type:'checkbox-group', id:'o_besoin', label:'Votre besoin', options:[
      'Améliorer le design','Améliorer la vitesse','Adapter le site au mobile','Améliorer le référencement','Améliorer le parcours client','Optimiser les pages','Optimiser les fiches produits','Autre']},
  ]},

  photographe: {title:'Photographe & vidéaste', fields:[
    {type:'checkbox-group', id:'p_besoin', label:'Votre besoin', options:[
      'Photos produits','Photos professionnelles','Vidéos produits','Vidéos pour réseaux sociaux','Shooting entreprise','Montage vidéo','Création de contenu','Autre']},
  ]},

  autre: {title:'Autre prestation', fields:[
    {type:'textarea', id:'a_besoin', label:'Décrivez la prestation que vous recherchez'},
  ]},
};

let qStep = 0;
let qSteps = [];
const answers = {};
const addOns = new Set();

function selectedPrestationKeys(){
  const keys = [];
  PRESTATION_CHOICES.forEach(p=>{
    if(cart.has(p.id) && !keys.includes(p.id)) keys.push(p.id);
  });
  if(cart.has('ecommerce') && !keys.includes('shopify')) keys.push('shopify');
  return keys;
}
function rebuildSteps(){
  qSteps = selectedPrestationKeys();
  if(qStep > qSteps.length + 1) qStep = qSteps.length + 1;
}

function fieldValue(id){ return answers[id]; }
function setFieldValue(id, v){ answers[id] = v; }

function renderField(f, prefix){
  const id = prefix + f.id;
  if(f.type === 'text'){
    return `<label class="field qfield">${f.label}<input type="text" data-ans="${id}" value="${answers[id]||''}"></label>`;
  }
  if(f.type === 'textarea'){
    return `<label class="field qfield">${f.label}<textarea data-ans="${id}" rows="5" style="padding:13px;border:1px solid var(--line);font:inherit">${answers[id]||''}</textarea></label>`;
  }
  if(f.type === 'checkbox-group'){
    const vals = answers[id] || [];
    const opts = f.options.map(o=>`<label class="check${vals.includes(o)?' checked':''}"><input type="checkbox" data-ans-group="${id}" value="${o}" ${vals.includes(o)?'checked':''}><span>${o}</span></label>`).join('');
    return `<div class="qfield">${f.label?('<div class="qlabel">'+f.label+'</div>'):''}<div class="check-grid cols2">${opts}</div></div>`;
  }
  if(f.type === 'radio'){
    const val = answers[id];
    const opts = f.options.map(o=>`<label class="radio-pill${val===o?' checked':''}"><input type="radio" name="${id}" data-ans-radio="${id}" value="${o}" ${val===o?'checked':''}><span>${o}</span></label>`).join('');
    let reveal = '';
    if(f.reveal){
      const when = Array.isArray(f.reveal.when) ? f.reveal.when : [f.reveal.when];
      if(when.includes(val)){
        const rid = prefix + f.reveal.id;
        if(f.reveal.type === 'checkbox'){
          const checked = !!answers[rid];
          reveal = `<label class="check reveal${checked?' checked':''}"><input type="checkbox" data-ans-check="${rid}" data-add="${f.reveal.add||''}" ${checked?'checked':''}><span>${f.reveal.label}</span></label>`;
        } else if(f.reveal.type === 'text'){
          reveal = `<label class="field qfield reveal">${f.reveal.label}<input type="text" data-ans="${rid}" value="${answers[rid]||''}"></label>`;
        } else if(f.reveal.type === 'checkbox-group'){
          const vals = answers[rid] || [];
          const opts2 = f.reveal.options.map(o=>`<label class="check${vals.includes(o)?' checked':''}"><input type="checkbox" data-ans-group="${rid}" value="${o}" ${vals.includes(o)?'checked':''}><span>${o}</span></label>`).join('');
          reveal = `<div class="qfield reveal"><div class="check-grid cols2">${opts2}</div></div>`;
        }
      }
    }
    return `<div class="qfield"><div class="qlabel">${f.label}</div><div class="radio-row">${opts}</div>${reveal}</div>`;
  }
  return '';
}

function renderStage(){
  const stage = document.getElementById('qStage');
  if(qStep === 0){
    stage.innerHTML = `
      <span class="qnum">VOTRE PROJET</span>
      <h3>Quelle prestation souhaitez-vous ?</h3>
      <div class="check-grid cols2" id="q_prestations_0">
        ${PRESTATION_CHOICES.map(p=>`<label class="check${cart.has(p.id)?' checked':''}" data-id="${p.id}"><input type="checkbox" ${cart.has(p.id)?'checked':''}><span>${p.label}</span></label>`).join('')}
      </div>`;
    stage.querySelectorAll('#q_prestations_0 .check').forEach(label=>{
      const id = label.dataset.id;
      label.querySelector('input').addEventListener('change', e=>{
        e.target.checked ? cart.add(id) : cart.delete(id);
        label.classList.toggle('checked', e.target.checked);
        renderOfferButtons(); rebuildSteps(); renderSummary();
      });
    });
  } else if(qStep <= qSteps.length){
    const key = qSteps[qStep-1];
    const sf = SUBFORMS[key];
    stage.innerHTML = `<span class="qnum">PRESTATION ${qStep} / ${qSteps.length}</span><h3>${sf.title}</h3>` + sf.fields.map(f=>renderField(f, key+'__')).join('');
    wireStageInputs();
  } else {
    stage.innerHTML = `
      <span class="qnum">DERNIÈRE ÉTAPE</span>
      <h3>Votre demande</h3>
      <label class="field qfield">Avez-vous une demande particulière ? Décrivez-nous votre projet, vos attentes ou tout élément qui pourrait nous aider à mieux comprendre votre besoin.
        <textarea id="q_desc" rows="5" style="padding:13px;border:1px solid var(--line);font:inherit">${answers.q_desc||''}</textarea>
      </label>
      <h3 style="margin-top:8px">Vos coordonnées</h3>
      <div class="qgrid cols2">
        <label class="field">Nom / Prénom<input type="text" id="q_name" value="${answers.q_name||''}"></label>
        <label class="field">Entreprise<input type="text" id="q_company" value="${answers.q_company||''}"></label>
        <label class="field">E-mail<input type="email" id="q_email" value="${answers.q_email||''}"></label>
        <label class="field">Téléphone<input type="tel" id="q_phone" value="${answers.q_phone||''}"></label>
      </div>`;
    ['q_desc','q_name','q_company','q_email','q_phone'].forEach(id=>{
      document.getElementById(id).addEventListener('input', e=> answers[id]=e.target.value);
    });
  }
  renderProgress();
  document.getElementById('qPrev').style.visibility = qStep===0 ? 'hidden' : 'visible';
  const atEnd = qStep === qSteps.length + 1;
  document.getElementById('qNext').textContent = atEnd ? 'Envoyer ma demande' : 'Étape suivante →';
}

function wireStageInputs(){
  const stage = document.getElementById('qStage');
  stage.querySelectorAll('input[data-ans]').forEach(inp=> inp.addEventListener('input', e=>{ setFieldValue(e.target.dataset.ans, e.target.value); }));
  stage.querySelectorAll('textarea[data-ans]').forEach(inp=> inp.addEventListener('input', e=>{ setFieldValue(e.target.dataset.ans, e.target.value); }));
  stage.querySelectorAll('input[data-ans-group]').forEach(inp=> inp.addEventListener('change', e=>{
    const id = e.target.dataset.ansGroup;
    let vals = answers[id] || [];
    if(e.target.checked) vals = vals.concat([e.target.value]); else vals = vals.filter(v=>v!==e.target.value);
    answers[id] = vals;
    e.target.closest('.check').classList.toggle('checked', e.target.checked);
  }));
  stage.querySelectorAll('input[data-ans-radio]').forEach(inp=> inp.addEventListener('change', e=>{
    answers[e.target.dataset.ansRadio] = e.target.value;
    renderStage();
  }));
  stage.querySelectorAll('input[data-ans-check]').forEach(inp=> inp.addEventListener('change', e=>{
    const id = e.target.dataset.ansCheck;
    answers[id] = e.target.checked;
    e.target.closest('.check').classList.toggle('checked', e.target.checked);
    const addId = e.target.dataset.add;
    if(addId){ e.target.checked ? addOns.add(addId) : addOns.delete(addId); }
    renderSummary();
  }));
}

function renderProgress(){
  const total = qSteps.length + 2;
  const done = qStep + 1;
  const p = document.getElementById('progress');
  p.innerHTML = Array.from({length: total}, (_,i)=>`<i class="${i < done ? 'done':''}"></i>`).join('');
}

document.getElementById('qPrev').addEventListener('click', ()=>{ if(qStep>0){ qStep--; renderStage(); }});
document.getElementById('qNext').addEventListener('click', ()=>{
  const atEnd = qStep === qSteps.length + 1;
  if(atEnd){ sendQuote(); return; }
  if(qStep===0 && qSteps.length===0){}
  qStep++; renderStage();
});

function syncStep0Checkboxes(){
  if(qStep !== 0) return;
  document.querySelectorAll('#q_prestations_0 .check').forEach(label=>{
    const on = cart.has(label.dataset.id);
    label.classList.toggle('checked', on);
    label.querySelector('input').checked = on;
  });
}

function renderSummary(){
  const ids = new Set([...cart, ...addOns]);
  const lines = [];
  ids.forEach(id=>{
    const key = prestationKey(id);
    const s = serviceById(key);
    if(!s) return;
    lines.push(s.name);
  });
  const body = document.getElementById('sumBody');
  body.innerHTML = lines.length
    ? lines.map(n=>`<div class="sum-line"><b>${n}</b></div>`).join('')
    : '<p class="summary-empty">Sélectionnez une prestation pour voir votre récapitulatif.</p>';
  document.getElementById('headCount').textContent = cart.size;
}

/* ---------- Envoi direct via le formulaire de contact natif Shopify (sans mailto) ---------- */
function submitToShopify(data, onDone){
  const form = document.getElementById('mailerForm');
  if(!form){ onDone(false); return; }
  form.querySelector('[name="contact[name]"]').value = data.name || '';
  form.querySelector('[name="contact[email]"]').value = data.email || '';
  form.querySelector('[name="contact[phone]"]').value = data.phone || '';
  form.querySelector('[name="contact[body]"]').value = data.body || '';
  fetch(form.action, { method: 'POST', body: new FormData(form) })
    .then(()=> onDone(true))
    .catch(()=> onDone(false));
}

function sendQuote(){
  const name = answers.q_name || '(non renseigné)';
  const email = answers.q_email || '(non renseigné)';
  const company = answers.q_company || '';
  const desc = answers.q_desc || '';

  const ids = new Set([...cart, ...addOns]);
  const lines = [];
  ids.forEach(id=>{
    const s = serviceById(prestationKey(id));
    if(!s) return;
    lines.push(`- ${s.name}`);
  });

  const detailLines = [];
  qSteps.forEach(key=>{
    const sf = SUBFORMS[key];
    const vals = sf.fields.map(f=>{
      const id = key+'__'+f.id;
      const v = answers[id];
      if(v==null || v==='' || (Array.isArray(v) && v.length===0)) return null;
      return `  ${f.label || f.id} : ${Array.isArray(v) ? v.join(', ') : v}`;
    }).filter(Boolean);
    if(vals.length) detailLines.push(`\n${sf.title} :\n` + vals.join('\n'));
  });

  const body = `Demande de devis — ${company||name}\n\nNom : ${name}\nEntreprise : ${company}\nTéléphone : ${answers.q_phone||''}\n\nPrestations souhaitées :\n${lines.join('\n') || '(aucune sélectionnée)'}\n${detailLines.join('\n')}\n\nDescription du projet :\n${desc}\n`;

  submitToShopify({name, email, phone: answers.q_phone, body}, (ok)=>{
    document.getElementById('quoteApp').querySelector('.quote-layout').style.display='none';
    document.getElementById('sentBox').classList.add('show');
  });
}
document.getElementById('backToQuote').addEventListener('click', ()=>{
  document.getElementById('sentBox').classList.remove('show');
  document.getElementById('quoteApp').querySelector('.quote-layout').style.display='';
});

document.getElementById('contactForm').addEventListener('submit', e=>{
  e.preventDefault();
  const f = new FormData(e.target);
  const btn = e.target.querySelector('button[type="submit"]');
  const msg = document.getElementById('contactMsg');
  const body = `Entreprise : ${f.get('entreprise')}\nObjet : ${f.get('objet')}\n\n${f.get('message')}`;
  if(btn) btn.disabled = true;
  submitToShopify({name: f.get('nom'), email: f.get('email'), phone: f.get('tel'), body}, (ok)=>{
    if(btn) btn.disabled = false;
    if(msg){
      msg.style.display = 'block';
      msg.style.color = ok ? 'var(--bronze)' : '#B3261E';
      msg.textContent = ok ? 'Merci, votre message a bien été envoyé.' : "Une erreur est survenue. Vous pouvez nous écrire directement à tchservice25@gmail.com.";
    }
    if(ok) e.target.reset();
  });
});

rebuildSteps(); renderStage(); renderSummary(); renderOfferButtons();

(function(){
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const els = document.querySelectorAll('.reveal, .reveal-stagger');
  if(reduce || !('IntersectionObserver' in window)){ els.forEach(e=>e.classList.add('is-visible')); return; }
  const io = new IntersectionObserver(entries=>{
    entries.forEach(entry=>{
      if(entry.isIntersecting){ entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
    });
  }, {threshold:.15, rootMargin:'0px 0px -40px 0px'});
  els.forEach(e=> io.observe(e));
})();

document.querySelectorAll('.faq-q').forEach(btn=>{
  btn.addEventListener('click', ()=>{
    const item = btn.closest('.faq-item');
    const wasOpen = item.classList.contains('open');
    item.parentElement.querySelectorAll('.faq-item.open').forEach(i=> i.classList.remove('open'));
    if(!wasOpen) item.classList.add('open');
  });
});

requestAnimationFrame(()=>{
  setTimeout(()=>{
    document.querySelectorAll('.hero-anim-item').forEach((el,i)=>{
      setTimeout(()=> el.classList.add('go'), i*110);
    });
  }, 60);
});

(function(){
  const header = document.querySelector('.header');
  if(!header) return;
  const onScroll = ()=> header.classList.toggle('scrolled', window.scrollY > 12);
  document.addEventListener('scroll', onScroll, {passive:true});
  onScroll();
})();
